// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListWithdrawal_status__hKjcw {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: capitalize;
  gap: 7px;
}
.ListWithdrawal_status--pending__20AI7 {
  background-color: #fff3e0;
  color: #e65100;
}
.ListWithdrawal_status--processed__kTiMt {
  background-color: #e8f5e9;
  color: #2e7d32;
}
.ListWithdrawal_status--rejected__zddZS {
  background-color: #ffebee;
  color: #c62828;
}`, "",{"version":3,"sources":["webpack://./src/components/ListWithdrawal/ListWithdrawal.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,QAAA;AACF;AACE;EACE,yBAAA;EACA,cAAA;AACJ;AAEE;EACE,yBAAA;EACA,cAAA;AAAJ;AAGE;EACE,yBAAA;EACA,cAAA;AADJ","sourcesContent":[".status {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  text-transform: capitalize;\n  gap: 7px;\n\n  &--pending {\n    background-color: #fff3e0;\n    color: #e65100;\n  }\n\n  &--processed {\n    background-color: #e8f5e9;\n    color: #2e7d32;\n  }\n\n  &--rejected {\n    background-color: #ffebee;\n    color: #c62828;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status": `ListWithdrawal_status__hKjcw`,
	"status--pending": `ListWithdrawal_status--pending__20AI7`,
	"status--processed": `ListWithdrawal_status--processed__kTiMt`,
	"status--rejected": `ListWithdrawal_status--rejected__zddZS`
};
export default ___CSS_LOADER_EXPORT___;
